import { useTranslation } from 'react-i18next'
import { PortfolioIcon } from '@/components/ui/PortfolioIcon'

export const About = () => {
  const { t } = useTranslation()
  const tiles = t('portfolio.about.tiles', { returnObjects: true }) as {
    title: string
    description: string
    alt: string
  }[]
  const images = [
    '/images/portfolio/hardware.webp',
    '/images/portfolio/software.webp',
    '/images/portfolio/products.webp',
  ]
  return (
    <section id="about" className="about-section section-pad">
      <div className="shell about-grid">
        <div className="section-copy">
          <p className="eyebrow">{t('portfolio.about.eyebrow')}</p>
          <h2>
            {t('portfolio.about.title')}
            <span>{t('portfolio.about.accent')}</span>
          </h2>
          <p>{t('portfolio.about.description')}</p>
          <p>{t('portfolio.about.extra')}</p>
          <a className="text-link" href="#contact">
            {t('portfolio.about.cta')}
            <PortfolioIcon name="arrow" />
          </a>
        </div>
        <div className="about-tiles">
          {tiles.map((tile, i) => (
            <figure key={tile.title}>
              <img
                src={images[i]}
                alt={tile.alt}
                width="176"
                height="140"
                loading="lazy"
              />
              <figcaption>
                <h3>{tile.title}</h3>
                <p>{tile.description}</p>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  )
}
